import { apiFetch } from "./client";

export async function fetchTimerState(type: string): Promise<unknown> {
  return apiFetch<unknown>(`/timer-state/${type}`);
}

export async function saveTimerState(type: string, state: object): Promise<void> {
  await apiFetch<void>(`/timer-state/${type}`, {
    method: "PUT",
    body: JSON.stringify(state),
  });
}
